import React, { useState, useEffect } from "react";
import Head from "next/head";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReactStars from "react-stars";
import {
  FaShareAlt,
  FaLocationArrow,
  FaMinus,
  FaPlus,
  FaTag,
  FaDownload,
  FaFileAlt,
  FaSlackHash,
  FaStoreAlt,
  FaEye,
  FaFilePdf,
  FaInfoCircle,
  FaCalculator,
} from "react-icons/fa";
import Link from "next/link";
import { productDetail, productReviews } from "../api.services.js/product";
import config from "../config";
import CustomerReview from "../src/components/customerReview";
import { useRouter } from "next/router";
import {
  createGuestEmptyCart,
  loggedInUserCartId,
  addToCart,
  addToCartWithPrice,
  getCartDataFromServer,
} from "../api.services.js/cart";
import swal from "sweetalert";
import JSZip from "jszip";
import axios from "axios";
import AddReviews from "../src/components/addReview";
import { RWebShare } from "react-web-share";
import {
  getIntouch,
  requestCallback,
  urlResolver,
} from "../api.services.js/others";
import { pageview, trackProductUnavailability } from "../gtag";
import cookie from "js-cookie";
import Spinner from "react-bootstrap/Spinner";
import Loader from "../src/components/loader";
import YouMayAlsoLike from "../src/components/product/youMayAlso";
import Confetti from "react-confetti";
import { Fireworks } from "@fireworks-js/react";

import useWindowSize from "react-use/lib/useWindowSize";
import { AES, enc } from "crypto-js";

// import 'react-image-magnify/dist/styles.css';
// export const getServerSideProps = async (context) => {
//    let productSlug = context.query.product;
//    let resolverResponse = await urlResolver({url:productSlug})
//    if(resolverResponse.data.urlResolver && resolverResponse.data.urlResolver.relative_url != productSlug){
//      return {
//        redirect: {
//          destination: `${config.HEADLESS_BASE_URL}/${resolverResponse.data.urlResolver.relative_url}`,
//          permanent: false,
//        },
//      };
//    }
//    const getProductSetail = await productDetail({
//       urlKey:productSlug
//    })
//    let response = await productReviews({ urlKey:productSlug})
//    return {
//      props: {getProductSetail,urlKey:productSlug,reviews:response.data.product_reviews.customer_review},
//    };
//  };
export const getServerSideProps = async (context) => {
  const productSlug = context.query.product;
  if (context.query.product == "index.html") {
    return {
      redirect: {
        destination: `/`,
        permanent: false,
      },
    };
  }
  const productKey = productSlug;
  let display404 = false;
  const [resolverResponse, productDetailResponse, productReviewsResponse] =
    await Promise.all([
      urlResolver({ url: productSlug }),
      productDetail({ urlKey: productSlug }),
      productReviews({ urlKey: productSlug }),
    ]);
  if (
    resolverResponse?.data?.urlResolver &&
    resolverResponse.data?.urlResolver.relative_url !== productSlug
  ) {
    return {
      redirect: {
        destination: `${config.HEADLESS_BASE_URL}/${resolverResponse.data?.urlResolver.relative_url}`,
        permanent: false,
      },
    };
  }
  if (
    productDetailResponse?.data?.products?.items?.length == 0 &&
    !config.CATALOUGEURLS.includes(`/${productSlug}`)
  ) {
    let configg = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://server.orientbell.com//rest/V1/products?searchCriteria[filter_groups][0][filters][0][field]=status&searchCriteria[filter_groups][0][filters][0][value]=2&searchCriteria[filter_groups][1][filters][0][field]=url_key&searchCriteria[filter_groups][1][filters][0][value]=${productSlug}`,
      headers: {
        Authorization: "Bearer v2qrwpqt530n1zi05gyvb6lk0ocekv5i",
      },
    };
    let prods = await axios.request(configg);
    display404 = prods.data.items.length ? prods.data.items[0].sku : false;
    if (!display404) {
      return {
        redirect: {
          destination: "/404",
          permanent: false,
        },
      };
    }
  }
  const reviews = productReviewsResponse?.data?.product_reviews?.customer_review
    ? productReviewsResponse?.data?.product_reviews?.customer_review
    : null;

  return {
    props: {
      display404,
      getProductSetail: productDetailResponse,
      productKey,
      reviews: reviews,
      productSlug: productSlug,
      urlKey: productSlug,
      catalougePage: config.CATALOUGEURLS.includes(`/${productSlug}`),
      displayLocationPopop: !config.CATALOUGEURLS.includes(`/${productSlug}`),
    },
  };
};
const Product = (props) => {
  const router = useRouter();
  if (!props?.getProductSetail?.data?.products?.items[0] && !props.display404) {
    return (
      <>
        <Head>
          <title>{router.asPath.replace("/", "").split("-").join(" ")}</title>
          <meta
            name="twitter:title"
            content={router.asPath.replace("/", "").split("-").join(" ")}
          />
          <meta
            itemprop="name"
            content={router.asPath.replace("/", "").split("-").join(" ")}
          />
          <meta
            property="og:title"
            content={router.asPath.replace("/", "").split("-").join(" ")}
          />
          <meta
            name="description"
            content="Orient Bell Limited (OBL) is amongst the largest manufacturers of Wall and Floor Tiles. Established in 1977, OBL has been a pioneer in the Industry with a focus"
          />
          <meta itemprop="bookFormat" content="EBook" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:image:src"
            content="files/assets/html/skin/images/fbThumb.jpg"
          />
          <meta property="og:type" content="article" />
          <meta
            name="image"
            property="og:image"
            content="files/assets/html/skin/images/fbThumb.jpg"
          />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:article:section" content="Article Section" />
        </Head>
        <iframe
          src={`${config.API_ENDPOINT}/${router.query.product}`}
          title={`${router.query.product}`}
          height="600px"
          width="100%"
        ></iframe>
      </>
    );
  }
  const [product, setProduct] = useState(
    props.getProductSetail.data.products.items[0]
  );
  const [productImg, setProductImg] = useState(
    props.getProductSetail.data.products.items[0]?.image?.url
  );
  const [reviews, setReviews] = useState(props.reviews);
  const [sellingPrice, setSellingPrice] = useState("");
  const [mrp, setMrp] = useState("");
  const [box, setBox] = useState(1);
  const [SqFt, setSqFt] = useState("");
  const [SqFtPerBox, setSqFtPerBox] = useState("");
  const [totalSellingPrice, setTotalSellingPrice] = useState("");
  const [totalMrpPrice, setTotalMrpPrice] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [Loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pincode, setPincode] = useState("");
  const [checkAviabilty, setCheckAviabilty] = useState(true);
  const [selectedSeze, setSelectedSeze] = useState("FT");
  const [updated_price_ft, setupdated_price_ft] = useState("");
  const [viewCount, setViewCount] = useState("");
  const [transportValue, settransportValue] = useState("");
  const [getInTouch, setGetInTouch] = useState(false);
  const [AvailableStock, setAvailableStock] = useState(0);
  const [ERPAvailableStock, setERPAvailableStock] = useState(
    !props.display404
      ? [
          Number(product.extraVariables.skd_stock),
          Number(product.extraVariables.dora_stock),
          Number(product.extraVariables.hoskote_stock),
          Number(product.extraVariables.west_zone_stock),
        ].reduce((total, obj) => total + obj, 0)
      : 0
  );
  const [similertiles, setsimilertiles] = useState([]);
  const [youmayalsolikee, setyoumayalsolikee] = useState([]);
  const { width, height } = useWindowSize();
  const [throwConfetti, setThrowConfetti] = useState(false);
  const [UnbxdRecomendatoRequestID, setUnbxdRecomendatoRequestID] =
    useState("");

  const [touch, setTouch] = useState({
    name: "",
    number: "",
  });

  const [videoURL, setvideoURL] = useState("");
  // const getProductReviews = async ()=>{
  //    let response = await productReviews({ urlKey:router.query.product}
  //    )
  //    setReviews(response.data.product_reviews.customer_review)
  // }
  const getYouMayAlsoLike = async (sku) => {
    let response = await axios.get(
      `https://apac-recommendations.unbxd.io/v3.0/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/recommendation?pageType=PRODUCT&id=${sku}&uid=${cookie.get(
        "unbxd.userId"
      )}&ip=%3Cip%3E`
    );
    if (response.status == 200) {
      let arr = response.data.response.widgets.filter(
        (cc) => cc.widgetId == "widget3"
      ).length
        ? response.data.response.widgets.filter(
            (cc) => cc.widgetId == "widget3"
          )[0].recommendations
        : [];
      let arr2 = response.data.response.widgets.filter(
        (cc) => cc.widgetId == "widget1"
      ).length
        ? response.data.response.widgets.filter(
            (cc) => cc.widgetId == "widget1"
          )[0].recommendations
        : [];
      const unbxdRequestId = response.headers.get("unbxd-request-id");
      let UnbxdVistType = cookie.get("unbxd.visit");
      let UnbxdVistID = cookie.get("unbxd.visitId");
      let UnbxdUserID = cookie.get("unbxd.userId");

      let UnbxdApiKey = "ss-unbxd-aapac-prod-orientbell53741713874410";

      setUnbxdRecomendatoRequestID(unbxdRequestId);
      //   var payload = {
      //    requestId: unbxdRequestId,
      //    pids_list: arr.map((cc)=>cc.uniqueId),
      //    experience_pagetype: 'Product',
      //    experience_widget: 'widget3'
      // }
      // "visit_type":"${UnbxdVistType}","visitId":"${UnbxdVistID}"&UnbxdKey="${UnbxdApiKey}"&action=experience_impression&uid="${UnbxdUserID}"`).toString())

      // axios.get(new URL(`https://tracker.unbxdapi.com/v2/1p.jpg?data={"experience_pagetype":"PRODUCT","experience_widget":"WIDGET3","pids_list":${arr.map((cc)=>`"${cc.uniqueId}"`)},"url":"https://www.orientbell.com","referrer":"","requestId":"${unbxdRequestId}","visit_type":"${UnbxdVistType}","visitId":"${UnbxdVistID}"}&UnbxdKey="${UnbxdApiKey}"&action=experience_impression&uid="${UnbxdUserID}"`).toString())
      // axios.get(`https://tracker.unbxdapi.com/v2/1p.jpg?data={"experience_pagetype":"PRODUCT","experience_widget":"WIDGET3","pids_list":${arr.map((cc)=>`"${cc.uniqueId}"`)},"url":"https://www.orientbell.com","referrer":"","requestId":"${unbxdRequestId}","visit_type":"${UnbxdVistType}","visitId":"${UnbxdVistID}"}&UnbxdKey="${UnbxdApiKey}"&action=experience_impression&uid="${UnbxdUserID}"`)
      axios.get(
        new URL(
          `https://tracker.unbxdapi.com/v2/1p.jpg?data=${encodeURIComponent(
            JSON.stringify({
              experience_pagetype: "PRODUCT",
              experience_widget: "WIDGET3",
              pids_list: arr.map((cc) => cc.uniqueId), // Pass the array directly
              url: "https://www.orientbell.com",
              referrer: "",
              requestId: unbxdRequestId,
              visit_type: UnbxdVistType,
              visitId: UnbxdVistID,
            })
          )}&UnbxdKey=${encodeURIComponent(
            UnbxdApiKey
          )}&action=experience_impression&uid=${encodeURIComponent(
            UnbxdUserID
          )}`
        ).toString()
      );

      axios.get(
        new URL(
          `https://tracker.unbxdapi.com/v2/1p.jpg?data=${encodeURIComponent(
            JSON.stringify({
              experience_pagetype: "PRODUCT",
              experience_widget: "WIDGET1",
              pids_list: arr2.map((cc) => cc.uniqueId), // Pass the array directly
              url: "https://www.orientbell.com",
              referrer: "",
              requestId: unbxdRequestId,
              visit_type: UnbxdVistType,
              visitId: UnbxdVistID,
            })
          )}&UnbxdKey=${encodeURIComponent(
            UnbxdApiKey
          )}&action=experience_impression&uid=${encodeURIComponent(
            UnbxdUserID
          )}`
        ).toString()
      );

      // var payload1 = {
      //    requestId: unbxdRequestId,
      //    pids_list: arr2.map((cc)=>cc.uniqueId),
      //    experience_pagetype: 'Product',
      //    experience_widget: 'widget1'
      // }
      // var action = 'experience_impression'
      // if(typeof Unbxd !== 'undefined' && Unbxd && typeof Unbxd.track === 'function') {
      //     Unbxd.track(action, payload)
      //     Unbxd.track(action, payload1)
      //    } else {
      //       console.log('unbxdAnalytics.js is not loaded!')
      //    }
      setsimilertiles(arr);
      setyoumayalsolikee(arr2);
    }
  };
  const getProdVideo = async (sku) => {
    try {
      let response = await axios.get(
        `https://obl-js.orientbell.com/getProdVideo?erp=${sku}`
      );
      if (response.status == 200) {
        if (response?.data?.status == "sucsess") {
          setvideoURL(response.data.link);
        } else {
          return;
        }
      }
    } catch (error) {
      return;
    }
  };
  const getLoggedInUserCart = async () => {
    if (localStorage.getItem("userToken")) {
      let cartId = await loggedInUserCartId({
        token: AES.decrypt(
          localStorage.getItem("userToken"),
          process.env.NEXT_PUBLIC_SECRET_KEY
        ).toString(enc.Utf8),
      });
      localStorage.setItem("cartId", cartId.data.customerCart.id);
    }
  };

  useEffect(() => {
    if (!props.display404) {
      setAvailableStock(
        [
          Number(product.extraVariables.skd_stock),
          Number(product.extraVariables.dora_stock),
          Number(product.extraVariables.hoskote_stock),
          Number(product.extraVariables.west_zone_stock),
        ].reduce((total, obj) => total + obj, 0)
      );
      setSqFt(Number(product.extraVariables.total_area_sq_ft).toFixed(2));
      setSqFtPerBox(product.extraVariables.total_area_sq_ft);
      setMrp(
        Math.round(
          Number(product.extraVariables.total_area_sq_ft) *
            Number(product.extraVariables.sq_ft_price)
        )
      );
      setTotalMrpPrice(
        Number(product.extraVariables.total_area_sq_ft) *
          Number(product.extraVariables.sq_ft_price)
      );
      setSellingPrice(
        Math.round(
          Number(product.extraVariables.total_area_sq_ft) *
            (Number(product.extraVariables.sq_ft_price) -
              Number(product.extraVariables.discounted_price))
        )
      );
      setTotalSellingPrice(
        Number(product.extraVariables.total_area_sq_ft) *
          (Number(product.extraVariables.sq_ft_price) -
            Number(product.extraVariables.discounted_price))
      );
      // getProductReviews()
      getLoggedInUserCart();
      if (cookie.get("pincode")) {
        getBestPrice(cookie.get("pincode"), product.extraVariables.factory);
        setPincode(Number(cookie.get("pincode")));
      }
      // console.log("8888", product)
      setViewCount(product.extraVariables.view_count);
      getProdVideo(product.sku);
      getYouMayAlsoLike(product.sku);
      var Unbxdpayload = {
        pid: product.sku,
        variantId: "",
      };
      if (
        typeof Unbxd !== "undefined" &&
        Unbxd &&
        typeof Unbxd.track === "function"
      ) {
        Unbxd.track("product_view", Unbxdpayload);
      } else {
        console.log("unbxdAnalytics.js is not loaded!");
      }
    } else {
      getYouMayAlsoLike(props.display404);
    }
  }, []);

  const handleSqFtChange = (e) => {
    if (e.target.value > 0) {
      let box = e.target.value / SqFtPerBox;
      setSqFt(e.target.value);
      setTotalMrpPrice(mrp * Math.ceil(box));
      setTotalSellingPrice(sellingPrice * Math.ceil(box));
      setBox(Math.ceil(box));
    } else {
      setSqFt(e.target.value);
      setTotalMrpPrice(mrp * 1);
      setTotalSellingPrice(sellingPrice * 1);
    }
  };
  const handlePlusBox = () => {
    let tBox = box + 1;
    setSqFt((tBox * SqFtPerBox).toFixed(2));
    setTotalMrpPrice(mrp * tBox);
    setTotalSellingPrice(sellingPrice * tBox);
    setBox(tBox);
  };
  const handleMinusBox = () => {
    if (box > 1) {
      let tBox = box - 1;
      setSqFt((tBox * SqFtPerBox).toFixed(2));
      setTotalMrpPrice(mrp * tBox);
      setTotalSellingPrice(sellingPrice * tBox);
      setBox(tBox);
    }
  };

  const addProductToCart = async (type) => {
    if (!deliveryDate) {
      swal("Please enter your pincode to add items in cart");
      return;
    }
    let UnbxdVistType = cookie.get("unbxd.visit");
    let UnbxdUserID = cookie.get("unbxd.userId");

    let UnbxdApiKey = "ss-unbxd-aapac-prod-orientbell53741713874410";
    if (localStorage.getItem("cartId")) {
      var Unbxdpayload2 = {
        pid: product.sku,
        variantId: "",
      };
      //Commenting CART CALL as aksed by Vineela
      //         if(typeof Unbxd !== 'undefined' && Unbxd && typeof Unbxd.track === 'function') {
      //    // Unbxd.track('addToCart', Unbxdpayload2)
      //    axios.get(
      //       new URL(
      //         `https://tracker.unbxdapi.com/v2/1p.jpg?data=${encodeURIComponent(
      //           JSON.stringify({
      //             pid: product.sku,
      //             qty: box,
      //             variantId: "",
      //             url: "https://www.orientbell.com",
      //             referrer: "",
      //             visit_type: UnbxdVistType,
      //             requestId: UnbxdRecomendatoRequestID,
      //           })
      //         )}&UnbxdKey=${encodeURIComponent(UnbxdApiKey)}&action=cart&uid=${encodeURIComponent(UnbxdUserID)}`
      //       ).toString()
      //     );
      //  } else {
      //    console.log('unbxdAnalytics.js is not loaded!')
      //  }
      let obj = {
        cartId: localStorage.getItem("cartId"),
        sku: product.sku,
        quantity: box,
        custom_price: sellingPrice,
        pincode: pincode,
      };
      if (localStorage.getItem("userToken")) {
        obj = {
          ...obj,
          token: AES.decrypt(
            localStorage.getItem("userToken"),
            process.env.NEXT_PUBLIC_SECRET_KEY
          ).toString(),
        };
      }
      try {
        if (type == "sample") {
          if (!localStorage.getItem("userToken")) {
            router.push(`/account?redirect=${props?.urlKey}`);
            return;
          }
          let cartDetailOfUser = await getCartDataFromServer(obj);
          if (
            cartDetailOfUser.data.cart.pincode &&
            cartDetailOfUser.data.cart.pincode != pincode &&
            cartDetailOfUser.data.cart.items?.length > 0
          ) {
            swal(
              `You already have some items in your cart for ${cartDetailOfUser.data.cart.pincode}, please remove items to continue with ${pincode}`
            );
            return;
          }
          if (
            cartDetailOfUser.data.cart.items?.length > 0 &&
            cartDetailOfUser.data.cart.items.filter(
              (cur) => cur.prices.price.value == 0
            ).length > 4
          ) {
            swal("you can't add more than 5 sample products in an order");
            return;
          }
          if (
            cartDetailOfUser.data.cart.items?.length > 0 &&
            cartDetailOfUser.data.cart.items.filter(
              (cur) =>
                cur.product.sku == product.sku && cur.prices.price.value == 0
            ).length
          ) {
            swal("You can't order more than 1 quantity for sample");
            return;
          }
          if (
            cartDetailOfUser.data.cart.items?.length > 0 &&
            cartDetailOfUser.data.cart.items.filter(
              (cur) =>
                cur.product.sku == product.sku && cur.prices.price.value != 0
            ).length
          ) {
            swal(
              "This product is already added in your cart as non-sample, please  remove it to order a sample"
            );
            return;
          }
          // if(cartDetailOfUser.data.cart.items.filter((cur)=>cur.prices.price.value > 0).length){
          //    swal("You Can't add Sample product with")
          //    return
          // }
          const addItem = await addToCartWithPrice({
            ...obj,
            quantity: 1,
            custom_price: 0,
          });
          if (addItem?.message) {
            swal(addItem.message);
          } else {
            localStorage.setItem(
              "CartData",
              JSON.stringify(addItem.data.addSimpleProductsToCartCustomPrice)
            );
            swal(`${product.name} added in your cart as sample`);
            const storageChangeEvent = new CustomEvent("localCartChanged", {
              detail: { key: "CartData", newValue: "" },
            });
            window.dispatchEvent(storageChangeEvent);
          }
          return;
        }
        if (!transportValue) {
          setGetInTouch(true);
          setThrowConfetti(false);
          return;
        }
        let cartDetailOfUser = await getCartDataFromServer(obj);
        if (
          cartDetailOfUser.data.cart.pincode &&
          cartDetailOfUser.data.cart.pincode != pincode &&
          cartDetailOfUser.data.cart.items?.length > 0
        ) {
          swal(
            `You already have some items in your cart for ${cartDetailOfUser.data.cart.pincode}, please remove items to continue with ${pincode}`
          );
          return;
        }
        if (
          cartDetailOfUser.data.cart.items?.length > 0 &&
          cartDetailOfUser.data.cart.items.filter(
            (cur) =>
              cur.product.sku == product.sku && cur.prices.price.value == 0
          ).length
        ) {
          swal(
            "Sample of this product is already in your cart, please remove it to continue buying it as a non-sample"
          );
          return;
        }
        //   const addedItem = await addToCart(obj);
        const addedItem = await addToCartWithPrice(obj);
        if (addedItem?.message) {
          swal(addedItem.message);
        } else {
          localStorage.setItem(
            "CartData",
            JSON.stringify(addedItem.data.addSimpleProductsToCartCustomPrice)
          );
          //  console.log(addedItem.data.addSimpleProductsToCart.cart,"uuuuuuuuuuuuuu")
          swal(`${product.name} Added in your Cart`);
          if (type == "buy") {
            router.push("/checkout");
          }
          const storageChangeEvent = new CustomEvent("localCartChanged", {
            detail: { key: "CartData", newValue: "" },
          });
          //  window.dispatchEvent(new Event('storage'));
          window.dispatchEvent(storageChangeEvent);
        }
      } catch (error) {
        console.log("Error occurred while adding to cart:", error);
      }
    } else {
      let emptyCart = await createGuestEmptyCart();
      localStorage.setItem("cartId", emptyCart.data.createEmptyCart);
      addProductToCart(type);
    }
  };
  // const downloadZip = (images) => {
  //    const zip = new JSZip();
  //    const promises = images.map((url, index) => {
  //       var myHeaders = new Headers();
  //       myHeaders.append("apiType", url.url);

  //       var requestOptions = {
  //          method: 'GET',
  //          headers: myHeaders,
  //        };
  //      return fetch(config.PROXY_SERVER_ENDPOINT,requestOptions)
  //        .then((response) => response.blob())
  //        .then((blob) => {
  //          zip.file(`image${index + 1}.jpg`, blob);
  //        });
  //    });
  //    Promise.all(promises)
  //      .then(() => zip.generateAsync({ type: 'blob' }))
  //      .then((content) => {
  //        const link = document.createElement('a');
  //        link.href = URL.createObjectURL(content);
  //        link.download = 'images.zip';
  //        link.click();
  //        URL.revokeObjectURL(link.href);
  //      });
  //  };
  const downloadZip = (images) => {
    if (!localStorage.getItem("userToken")) {
      router.push(`/account?redirect=${props?.urlKey}`);
      return;
    }
    const imageUrls = images.map((cur) => cur?.url);

    fetch(`${config.PROXY_SERVER_ENDPOINT}download/zip`, {
      //  fetch(`http://localhost:3001/api/zip`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ imageUrls }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Access the generated ZIP file URL
        const zipUrl = data.zipUrl;
        // Use the ZIP file URL as needed
        const newWindow = window.open(zipUrl, "_blank");
        newWindow.opener = null;
      })
      .catch((error) => {
        console.log("Failed to generate ZIP file:", error);
      });
  };
  const productsliderthumb = {
    dots: false,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    beforeChange: function (currentSlide, nextSlide) {
      //   console.log("before change", currentSlide, nextSlide);
    },
    afterChange: function (currentSlide) {
      //   console.log("after change", currentSlide);
    },
  };
  const submitGetInTouch = async (subsource) => {
    const namee = touch.name;
    const no = touch.number;

    if (!namee || !no) {
      setTouch({
        ...touch,
        error: "Both fields are required",
      });
    } else if (String(no).length > 13 || String(no).length < 9) {
      setTouch({
        ...touch,
        error: "Invalid Phone number",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });

      try {
        let response = await getIntouch({
          name: namee,
          phone: no,
          pincode: pincode,
          call_id: subsource,
        });
        if (response?.message) {
          localStorage.setItem("leadfilled", true);
          swal(response?.message);
        } else {
          swal(response.data.get_in_touch.msg);
          setGetInTouch(false);
          setTouch({
            name: "",
            number: "",
            pincode: "",
            error: "",
            loading: false,
            email: "",
          });
        }
      } catch (error) {
        console.log("Error submitting form:", error);
        setTouch({
          ...touch,
          error: "Error submitting form",
          loading: false,
        });
      }
    }
  };
  const settings3 = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: true,
    centerPadding: "0px",
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const [bestPricesLoading, setBestPricesLoading] = useState(false);

  useEffect(() => {
    const loadYouTubeAPI = () => {
      if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
        // Load the YouTube IFrame API script
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        tag.async = true;
        document.body.appendChild(tag);

        // Define the global API ready function
        window.onYouTubeIframeAPIReady = initializePlayer;
      } else {
        initializePlayer();
      }
    };

    const initializePlayer = () => {
      if (videoURL) {
        const videoId = getYouTubeVideoID(videoURL); // Extract the video ID
        new YT.Player("youtube-player", {
          videoId: videoId,
          events: {
            onStateChange: onPlayerStateChange,
          },
        });
      }
    };

    const onPlayerStateChange = (event) => {
      if (event.data === YT.PlayerState.PLAYING) {
        // Log the play event to Google Analytics
        window.gtag("event", "Quicklook video play", {
          event_category: "Video",
          event_label: "YouTube Video",
        });
      }
    };

    const getYouTubeVideoID = (url) => {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return match ? match[1] : null;
    };

    // Load the YouTube API script
    loadYouTubeAPI();
  }, [videoURL]);

  const getBestPrice = async (pin, factory) => {
    setBestPricesLoading(true);
    if (!pin?.length == 6) {
      swal("please enter valid pincode to get best prices");
    } else {
      let apiresult = await axios.get(
        `https://obl-js.orientbell.com/api/product-availability-dev?sku=${product.sku}&pincode=${pin}&factory=${factory}`
      );
      if (apiresult.data?.devliverytime) {
        if (apiresult.data?.Plants?.length > 0) {
          let temparr = [];
          if (apiresult.data?.Plants.includes("Sikandrabad Plant")) {
            temparr.push(Number(product.extraVariables.skd_stock));
          }
          if (apiresult.data?.Plants.includes("Dora Plant")) {
            temparr.push(Number(product.extraVariables.dora_stock));
          }
          if (apiresult.data?.Plants.includes("Hoskote Plant")) {
            temparr.push(Number(product.extraVariables.hoskote_stock));
          }
          if (apiresult.data?.Plants.includes("West Zone")) {
            temparr.push(Number(product.extraVariables.west_zone_stock));
          }
          setAvailableStock(temparr.reduce((total, obj) => total + obj, 0));
        }
        if (apiresult.data?.transportOrder == 0) {
          setThrowConfetti(false);
          setDeliveryDate(apiresult.data?.devliverytime);
          setBestPricesLoading(false);
          settransportValue(apiresult.data?.transportOrder);
          return;
        }
        setDeliveryDate(apiresult.data?.devliverytime);
        setBestPricesLoading(false);
        settransportValue(apiresult.data?.transportOrder);
        if (apiresult.data.updated_price == 0) {
          setGetInTouch(true);
          // setIsModalOpen("You have the best offer right now.")
          setCheckAviabilty(true);
          // swal("You have the best offer right now.")
        } else if (
          apiresult.data?.updated_price_ft &&
          apiresult.data?.updated_price_ft *
            product.extraVariables.total_area_sq_ft <
            Math.round(
              Number(product.extraVariables.total_area_sq_ft) *
                (Number(product.extraVariables.sq_ft_price) -
                  Number(product.extraVariables.discounted_price))
            )
        ) {
          setThrowConfetti(true);
          // alert(Math.round(apiresult.data?.updated_price_ft * SqFtPerBox))
          function percentageDiscount(a, b) {
            let res = Math.round(((a - b) / a) * 100);
            return res;
          }
          let perrr = percentageDiscount(
            Math.round(
              Number(product.extraVariables.total_area_sq_ft) *
                (Number(product.extraVariables.sq_ft_price) -
                  Number(product.extraVariables.discounted_price))
            ),
            apiresult.data?.updated_price_ft *
              product.extraVariables.total_area_sq_ft
          );
          const seeelling = Math.round(
            Number(product.extraVariables.total_area_sq_ft) *
              (Number(product.extraVariables.sq_ft_price) -
                Number(product.extraVariables.discounted_price))
          );
          setMrp(seeelling);
          setSellingPrice(
            Math.round(
              apiresult.data?.updated_price_ft *
                product.extraVariables.total_area_sq_ft
            )
          );
          setTotalMrpPrice(seeelling * box);
          setTotalSellingPrice(
            apiresult.data?.updated_price_ft *
              product.extraVariables.total_area_sq_ft *
              box
          );
          setupdated_price_ft(apiresult.data?.updated_price_ft);
          setIsModalOpen(
            `Hey, you just saved ${perrr}% on price. Hurry! Offer price for limited period.`
          );
          setBestPricesLoading(false);
          setCheckAviabilty(true);
          setTimeout(() => {
            setThrowConfetti(false);
          }, 3000);
        }
      } else if (1 > apiresult.data.availableQty) {
        setThrowConfetti(false);
        setIsModalOpen(`This Product is out of stock at ${pin}`);
        setBestPricesLoading(false);
        setPincode("");
        setCheckAviabilty(false);
      } else if (
        apiresult.data.addesses == "" ||
        !apiresult.data.devliverytime
      ) {
        // setDeliveryDate(apiresult.data?.devliverytime)
        setThrowConfetti(false);
        setIsModalOpen(`This Product is not Deliverable at ${pin}`);
        //trackProductUnavailability(product.sku, pin)
        setBestPricesLoading(false);
        setPincode("");
        setCheckAviabilty(false);
      }
    }
  };
  const breadsCrumbSchema = () => {
    return {
      __html: `{
      "@context": "https://schema.org/", 
      "@type": "BreadcrumbList", 
      "itemListElement": [{
        "@type": "ListItem", 
        "position": 1, 
        "name": "Home",
        "item": "https://www.orientbell.com"
      },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Tiles",
        "item": "https://www.orientbell.com/tiles"  
      },{
       "@type": "ListItem", 
       "position": 3, 
       "name": "${product?.name}",
       "item": "${router.asPath}"  
     }]}`,
    };
  };
  const webPageSchema = () => {
    return {
      __html: `{
      "@context": "https://schema.org",
      "@type": "WebPage",
      "url": "${router.asPath}",
      "headline": "",
      "name": "${product?.name}",
      "description": "Shop online ${product?.name}  Tiles at best price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!"
    }`,
    };
  };
  let productSchema = () => null;
  if (props.getProductSetail?.data?.products?.items?.length > 0) {
    productSchema = () => {
      const schema = {
        "@context": "https://schema.org",
        "@type": "Product",
        brand: "Orientbell",
        URL: `${config.HEADLESS_BASE_URL}/${props.productSlug}`,
        category: `${props.getProductSetail.data.products.items[0].extraVariables.suitable_for.map(
          (cur, index) => {
            return cur.label;
          }
        )}`,
        description: `Shop online ${props.getProductSetail.data.products.items[0]?.name} Floor  Tiles at the best price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from the nearest tiles store!`,
        name: `${props.getProductSetail.data.products.items[0]?.name}`,
        manufacturer: "Orient Bell Limited",
        material: `${props.getProductSetail.data.products.items[0].extraVariables.material.map(
          (cur, index) => {
            return cur.label;
          }
        )}`,
        image: `${props.getProductSetail.data.products.items[0].image?.url}`,
        offers: {
          "@type": "Offer",
          url: `${config.HEADLESS_BASE_URL}/${props.productSlug}`,
          priceCurrency: "INR",
          price: `${props.getProductSetail.data.products.items[0].extraVariables.sq_ft_price}`,
          itemOffered: "/sqft",
        },
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5.00",
          ratingCount: `${
            props.getProductSetail.data.products.items[0].extraVariables
              .rating_summary?.avg_rating
              ? props.getProductSetail.data.products.items[0].extraVariables.rating_summary?.avg_rating.toFixed(
                  2
                )
              : 5
          }`,
        },
        review:
          reviews?.length > 0
            ? reviews.map((rev) => {
                return {
                  "@type": "Review",
                  reviewRating: {
                    "@type": "Rating",
                    ratingValue: `${rev.rating}`,
                    bestRating: "5",
                  },
                  reviewBody: `${rev.detail}`,
                  author: {
                    "@type": "Person",
                    name: `${rev.customer_name}`,
                  },
                };
              })
            : "",
      };

      // Convert the JavaScript object to a JSON string
      const jsonString = {
        __html: JSON.stringify(schema).replace(/&quot;/g, '"'),
      };

      // Return the JSON string
      return jsonString;
    };
  }

  const imageObjectSchema = () => {
    const images =
      props.getProductSetail?.data?.products?.items[0].extraVariables.images ||
      [];
    // const altText = `${props.getProductSetail.data.products.items[0].extraVariables.finish[0].label} ${props.getProductSetail.data.products.items[0].name} ${props.getProductSetail.data.products.items[0].extraVariables.material[0].label} ${props.getProductSetail.data.products.items[0].extraVariables.type[0].label || props.getProductSetail.data.products.items[0].extraVariables.tile_size}`;

    // Build the schema with @context and @graph for multiple ImageObjects
    const schema = {
      "@context": "https://schema.org",
      "@graph": images.map((image) => ({
        "@type": "ImageObject",
        contentUrl: image.url,
        description: generateAltText(),
        caption: generateAltText(),
        width: "600",
        height: "900",
      })),
    };

    // Return JSON-LD formatted HTML-safe string
    return { __html: JSON.stringify(schema) };
  };

  //  console.log("PRODUCT ------", product)
  const [callBackDto, setCallBackDto] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
    countryCode: "",
    email: "",
    cc: "",
  });
  const onSubmitClick = async () => {
    const namee = callBackDto.name;
    const no = callBackDto.number;
    if (!namee || !no) {
      setCallBackDto({
        ...callBackDto,
        error: "Both Field Are Required",
      });
    } else {
      setCallBackDto({
        ...callBackDto,
        error: "",
        loading: true,
      });
      //gtagConversionEvent()
      let response = await requestCallback({
        name: namee,
        phone: no,
        pincode: callBackDto.pincode ? callBackDto.pincode : "",
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);
        swal(response?.message);
        setCallBackDto({
          ...callBackDto,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.request_callback.msg);
        setCallBackDto({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
      }
    }
  };
  const onValueChange = (e, title) => {
    setCallBackDto({
      ...callBackDto,
      [title]: e.target.value,
    });
  };

  const generateAltText = () => {
    const finish =
      props?.getProductSetail?.data?.products?.items[0]?.extraVariables
        ?.finish[0]?.label || "";
    const material =
      props?.getProductSetail?.data?.products?.items[0]?.extraVariables
        ?.material[0]?.label || "";
    const type =
      props?.getProductSetail?.data?.products?.items[0]?.extraVariables?.type[0]
        ?.label != "false"
        ? props?.getProductSetail?.data?.products?.items[0]?.extraVariables
            ?.type[0]?.label
        : "";

    const size =
      props?.getProductSetail?.data?.products?.items[0]?.extraVariables
        ?.tile_size || "";
    const productName =
      props?.getProductSetail?.data?.products?.items[0]?.name || "";

    if (type && material.toLowerCase().includes("tile")) {
      return `${finish} ${productName} ${material} ${type}`;
    } else {
      const materialWithTile = material.toLowerCase().includes("tile")
        ? material
        : `${material} tile`;
      return `${finish} ${productName} ${materialWithTile} ${size}`;
    }
  };

  return (
    <>
      {/* {ERPAvailableStock < 50 || props.display404 ?  <div class="container" style={{paddingTop:"30px"}}> */}
      {props.display404 ? (
        <div className="container" style={{ paddingTop: "30px" }}>
          <p
            className="back-to-hp-txt"
            onClick={() => {
              router.push("/");
            }}
          >
            {" "}
            <span>←</span> Back to homepage
          </p>
          <div className="error-section" style={{ backgroundImage: "none" }}>
            <div className="error-figure">
              <img src="/404-img.png" alt="404 image" className="img-fluid" />
            </div>
            <div className="error-content">
              <div className="error-text-bx">
                <h2>Error 404 tile not found</h2>
                <div className="ft-fromUs-row flex-class">
                  <div className="fr-Title">Request a Callback</div>
                  <div className="us-form-col">
                    <p>Get a call back when tiles back in stock</p>
                    <form className="flex-class">
                      <div className="form-group pdp-form">
                        <input
                          type="text"
                          value={callBackDto.name}
                          onChange={(e) => {
                            onValueChange(e, "name");
                          }}
                          placeholder="Name"
                          className="input-bx"
                        />
                      </div>
                      <div className="form-group pdp-form">
                        <input
                          type="number"
                          value={callBackDto.number}
                          onChange={(e) => {
                            onValueChange(e, "number");
                          }}
                          placeholder="Mobile Number"
                          className="input-bx"
                        />
                      </div>
                      <div className="form-group button pdp-form">
                        {callBackDto.loading ? (
                          <Button className="ft-submit-btn">Submitting</Button>
                        ) : (
                          <Button
                            className="ft-submit-btn"
                            onClick={() => onSubmitClick()}
                          >
                            Submit
                          </Button>
                        )}
                      </div>
                      {callBackDto.error && (
                        <p className="error text-danger">{callBackDto.error}</p>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {similertiles.length ? (
            <div className="pro_similartiles">
              <h2>Similar Tiles</h2>
              <YouMayAlsoLike
                products={similertiles}
                UnbxdRecomendatoRequestID={UnbxdRecomendatoRequestID}
                widget={"WIDGET3"}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <>
          <Head>
            <meta charset="utf-8" />
            <meta
              name="title"
              content={`Buy ${product?.name} ${
                product?.extraVariables?.type[0].label !== "false"
                  ? product.extraVariables.type[0].label
                  : "Floor and Wall Tiles"
              } Online | Orientbell Tiles`}
            />
            <title>{`Buy ${product?.name}  ${
              product?.extraVariables?.type[0].label !== "false"
                ? product.extraVariables.type[0].label
                : "Floor and Wall Tiles"
            } Online | Orientbell Tiles`}</title>
            <meta
              name="description"
              content={`Shop online ${product?.name}  Tiles at the right price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!`}
            />
            {/* <meta name="keywords" content={product?.extraVariables?.meta_keywords}/> */}
            <meta
              name="keywords"
              content={`${product?.name}, ${product?.name} tiles, Orientbell ${product?.name} tiles, ${product?.name} tiles price, ${product?.name} tiles specification, ${product?.name} tiles ${product?.extraVariables?.size} mm`}
            />
            {/* <meta name="robots" content="noindex,nofollow"/> */}
            <meta name="format-detection" content="telephone=no" />
            <meta name="pinterest-rich-pin" content="false" />
            <meta
              name="twitter:description"
              content={`Shop online ${product?.name}  Tiles at the right price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!`}
            />
            <meta
              name="twitter:image"
              content={product?.extraVariables?.image_url}
            />
            <meta name="twitter:url" content={product?.image?.url} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="Orientbell" />
            <meta name="twitter:creator" content="Orientbell" />
            <meta
              property="og:title"
              content={`Buy ${product?.name} Floor  Tiles Online | Orientbell Tiles`}
            />
            <meta
              property="og:description"
              content={`Shop online ${product?.name}  Tiles at the right price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!`}
            />
            <meta
              property="og:image"
              content={product?.extraVariables?.image_url}
            />
            <meta property="og:url" content={product?.image?.url} />
            <meta property="og:type" content="og:product" />
            <script
              type="text/javascript"
              src="https://cdn.roomvo.com/static/scripts/b2b/orientbell.js"
              defer=""
            ></script>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={productSchema()}
            >
              {/* {productSchema()} */}
            </script>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={imageObjectSchema()}
            ></script>

            {/* <script type="text/javascript" dangerouslySetInnerHTML={{
        __html: `
          var UnbxdSiteName = "ss-unbxd-aapac-prod-orientbell53741713874410";
          var UnbxdApiKey = "5a4b9251b67027ff94d260e4ac6ac09e";
          (function() {
            var ubx = document.createElement('script');
            ubx.type = 'text/javascript';
            ubx.async = true;
            ubx.src = '//libraries.unbxdapi.com/ua-js/v1.0.0/uaLibrary.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(ubx);
          })();
        `,
      }} /> */}
            {/* <script
      type="application/ld+json"
      dangerouslySetInnerHTML={ {__html:productSchema()}}
    /> */}
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={webPageSchema()}
            />
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={breadsCrumbSchema()}
            />
          </Head>

          <Modal
            show={show}
            onHide={handleClose}
            className="exclamation_size_modal"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <img
                src="../tiles-size-guide.jpg"
                style={{ width: "100%" }}
                alt="image"
              />
            </Modal.Body>
          </Modal>

          {isModalOpen && (
            <Modal
              className="product_defaultModal"
              size="lg"
              show={isModalOpen}
              onHide={handleCloseModal}
            >
              <Modal.Header closeButton>
                <Modal.Title>{isModalOpen}</Modal.Title>
              </Modal.Header>
              <Button variant="primary" onClick={handleCloseModal}>
                Close
              </Button>
            </Modal>
          )}

          {Loading ? (
            <>
              <Loader />
            </>
          ) : (
            <div className="productdetail">
              <div className="container_new">
                <div className="breadcumb">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href="/tiles">Tiles</Breadcrumb.Item>
                    <Breadcrumb.Item active>{product?.name}</Breadcrumb.Item>
                  </Breadcrumb>
                  <div>
                    <RWebShare
                      data={{
                        text: product.name,
                        url: `${config.HEADLESS_BASE_URL}/${props?.urlKey}`,
                        title: product.name,
                      }}
                      sites={["whatsapp", "facebook", "linkedin", "copy"]}
                    >
                      <p>
                        Share on <FaShareAlt />
                      </p>
                    </RWebShare>
                  </div>
                </div>
                <div className="productslider-row-asas">
                  <div className="productslider">
                    <div className="product-left">
                      <div className="product_desktop_view_slider">
                        <div className="thumbnail-bx">
                          <Slider {...productsliderthumb}>
                            {product.media_gallery?.map((e, i) => {
                              return (
                                <div
                                  key={i}
                                  onClick={() => {
                                    setProductImg(e?.url);
                                  }}
                                >
                                  <img
                                    src={e?.url}
                                    title={generateAltText()}
                                    alt={generateAltText()}
                                  />
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                        <div className="product-img-view">
                          <img
                            src={productImg}
                            style={{ width: "100%" }}
                            title={generateAltText()}
                            alt={generateAltText()}
                          />
                          {/* <a href="#" className="my-room-btn">Try Product in your room</a> */}
                          <div
                            className="roomvo-container"
                            data-product-type-str=""
                          >
                            <button
                              className="roomvo-stimr listing-button my-room-btn"
                              data-sku={product.sku}
                              style={{ visibility: "hidden" }}
                            >
                              Try in my room
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="product_mobile_view_slider">
                        <Slider {...settings3}>
                          {product.media_gallery.map((e, i) => {
                            return (
                              <div key={i}>
                                <div className="product-img-view">
                                  <img
                                    src={e?.url}
                                    title={generateAltText()}
                                    alt={generateAltText()}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                        <div
                          className="roomvo-container"
                          data-product-type-str=""
                        >
                          <button
                            className="roomvo-stimr listing-button my-room-btn"
                            data-sku={product.sku}
                            style={{ visibility: "hidden" }}
                          >
                            Try in my room
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="productpara">
                    {viewCount > 0 && (
                      <p>
                        <span className="view-count">
                          <img src="/upword-arrow.svg"></img>{" "}
                          <i class="fa-solid fa-arrow-trend-up"></i>Recent
                          views: &nbsp;<strong> {viewCount}</strong>
                        </span>
                      </p>
                    )}
                    <h1 className="mt-0">{product.name}</h1>
                    <div className="prorating">
                      {product.extraVariables.rating_summary?.avg_rating ? (
                        <>
                          <div class="product-rating-row">
                            <ReactStars
                              count={5}
                              value={
                                product.extraVariables.rating_summary
                                  ?.avg_rating
                              }
                              edit={false}
                              color2={"#ff5e00"}
                            />
                            <div
                              style={{ paddingLeft: "5px", fontSize: "13px" }}
                              itemscope=""
                              itemtype="http://schema.org/AggregateRating"
                            >
                              {product.extraVariables.rating_summary?.avg_rating.toFixed(
                                2
                              )}{" "}
                              Rating
                            </div>
                          </div>

                          <p
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={
                              product.extraVariables.rating_summary
                                .avg_percentage
                            }
                          ></p>
                        </>
                      ) : (
                        <p></p>
                      )}

                      {/* {checkAviabilty ? <small>Available ({AvailableStock.toFixed(2)})</small> :<small className='new_avialabily'>Not Deliverable</small>} */}
                      <small>
                        {checkAviabilty ? (
                          <>
                            <span
                              style={{
                                display: "inline-block",
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor:
                                  AvailableStock > 0 && AvailableStock <= 100
                                    ? "red"
                                    : AvailableStock > 100 &&
                                      AvailableStock <= 250
                                    ? "orange"
                                    : AvailableStock > 250 &&
                                      AvailableStock <= 1000
                                    ? "lightgreen"
                                    : AvailableStock > 1000
                                    ? "darkgreen"
                                    : "grey",
                                marginRight: "5px",
                              }}
                            ></span>
                            {AvailableStock > 0 && AvailableStock <= 100
                              ? "Out of Stock"
                              : AvailableStock > 100 && AvailableStock <= 250
                              ? "Low Stock"
                              : AvailableStock > 250 && AvailableStock <= 1000
                              ? "Limited Stock"
                              : AvailableStock > 1000
                              ? "In Stock"
                              : "Out of Stock"}{" "}
                            {/* ({AvailableStock.toFixed(2)}) */}
                          </>
                        ) : (
                          <span className="new_avialabily">
                            Not Deliverable
                          </span>
                        )}
                      </small>
                    </div>
                    <div className="prolocation">
                      <Form onSubmit={(e) => e.preventDefault()}>
                        <InputGroup className="p-2">
                          <InputGroup.Text id="basic-addon1">
                            <FaLocationArrow />
                          </InputGroup.Text>
                          <Form.Control
                            placeholder="Enter pincode"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            type="number"
                            value={pincode}
                            onChange={(e) => {
                              if (String(e.target.value).length <= 6) {
                                if (String(e.target.value).length == 6) {
                                  // if(!localStorage.getItem('pincode')){
                                  //     setThrowConfetti(true)
                                  // }
                                  getBestPrice(
                                    e.target.value,
                                    product.extraVariables.factory
                                  );
                                  setBestPricesLoading();
                                  setPincode(e.target.value);
                                  cookie.set("pincode", e.target.value, {
                                    expires: 7,
                                  });
                                } else {
                                  setPincode(e.target.value);
                                }
                              }
                            }}
                          />
                        </InputGroup>
                        {bestPricesLoading && (
                          <>
                            {" "}
                            <Spinner
                              animation="border"
                              variant="success"
                              size="sm"
                            />
                            <span>Loading...</span>
                          </>
                        )}
                        {deliveryDate ? (
                          <p className="deliv_date">
                            Expected Delivery by <strong>{deliveryDate}</strong>
                          </p>
                        ) : (
                          <p className="text-danger">
                            Please enter your pincode for best prices
                          </p>
                        )}
                        <div className="p-2">
                          <div className="pro_forminline">
                            <div>
                              <Form.Label htmlFor="inputPassword5">
                                Total Area (Sq.ft.)
                              </Form.Label>
                              <Form.Control
                                type="Number"
                                id="inputPassword5"
                                value={SqFt}
                                aria-describedby="passwordHelpBlock"
                                onChange={handleSqFtChange}
                              />
                            </div>
                            <div className="procounter">
                              <Form.Label htmlFor="inputPassword5">
                                Boxes
                              </Form.Label>
                              <div className="pro_counterdata">
                                <button onClick={handleMinusBox}>
                                  <FaMinus />
                                </button>
                                <p>{box}</p>
                                <button onClick={handlePlusBox}>
                                  <FaPlus />
                                </button>
                              </div>
                            </div>
                          </div>
                          {mrp > sellingPrice ? (
                            <p className="pr_loc_total">
                              Estimated Price
                              <span>Rs. {Math.round(totalMrpPrice)} </span>
                              <storng>
                                Rs.{Math.round(totalSellingPrice)}
                              </storng>
                              <span className="disclaimer-price-txt">
                                (Final Price Adjusted before Delivery)
                              </span>
                            </p>
                          ) : (
                            <p className="pr_loc_total">
                              Estimated Price
                              <storng>
                                Rs. {Math.round(totalSellingPrice)}
                              </storng>
                            </p>
                          )}
                          <Button
                            className={`${
                              String(pincode).length === 6
                                ? "add-to-cart-on-pdp"
                                : ""
                            }`}
                            onClick={() => addProductToCart("add")}
                            variant="outline-success"
                            //   unbxdattr="AddToCart"
                            unbxdparam_sku={product?.sku}
                            unbxdparam_variant="null"
                            unbxdparam_qty="1"
                          >
                            ADD TO CART
                          </Button>

                          <Button
                            className={`${
                              String(pincode).length === 6
                                ? "buy-now-on-pdp"
                                : ""
                            }`}
                            onClick={() => addProductToCart("buy")}
                            variant="primary"
                          >
                            <FaTag className="faTagIcon" />
                            BUY NOW
                          </Button>
                        </div>
                      </Form>
                    </div>
                    <div className="prodeatilcard">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <h2>Details</h2>
                          </Accordion.Header>
                          <Accordion.Body>
                            {Array.isArray(product.extraVariables.material) &&
                              product.extraVariables.material?.filter(
                                (cur) => cur?.label != "false"
                              ).length > 0 && (
                                <p>
                                  <span>Material</span>
                                  {product.extraVariables.material.map(
                                    (e, i) => {
                                      return (
                                        <Link
                                          key={i}
                                          href={`${config.HEADLESS_BASE_URL}/${e.url_key}`}
                                        >
                                          {" "}
                                          {e.label}{" "}
                                          {i + 1 !=
                                            product.extraVariables.material
                                              .length && ","}
                                        </Link>
                                      );
                                    }
                                  )}
                                </p>
                              )}

                            {Array.isArray(product.extraVariables.finish) &&
                              product.extraVariables.finish?.filter(
                                (cur) => cur?.label != "false"
                              ).length > 0 && (
                                <p>
                                  <span>Finish</span>
                                  {product.extraVariables.finish.map((e, i) => {
                                    return (
                                      <Link
                                        key={i}
                                        href={`${config.HEADLESS_BASE_URL}/${e.url_key}`}
                                      >
                                        {" "}
                                        {e.label}{" "}
                                        {i + 1 !=
                                          product.extraVariables.finish
                                            .length && ","}
                                      </Link>
                                    );
                                  })}
                                </p>
                              )}

                            {Array.isArray(product.extraVariables.type) &&
                              product.extraVariables.type?.filter(
                                (cur) => cur?.label != "false"
                              ).length > 0 && (
                                <p>
                                  <span>Type</span>
                                  {product.extraVariables.type.map((e, i) => {
                                    return (
                                      <Link
                                        key={i}
                                        href={`${config.HEADLESS_BASE_URL}/${e.url_key}`}
                                      >
                                        {" "}
                                        {e.label}{" "}
                                        {i + 1 !=
                                          product.extraVariables.type.length &&
                                          ","}
                                      </Link>
                                    );
                                  })}
                                </p>
                              )}
                            {product.extraVariables.size_option.filter(
                              (cur) => cur.label != "false"
                            )?.length > 0 && (
                              <p>
                                <span>
                                  Size{" "}
                                  <span
                                    className="exclamation_icon"
                                    onClick={handleShow}
                                  >
                                    <img
                                      height="20px"
                                      src="/infoicon.png"
                                    ></img>
                                  </span>
                                </span>
                                {product.extraVariables.size_option.map(
                                  (e, i) => {
                                    return (
                                      <Link
                                        key={i}
                                        href={`${config.HEADLESS_BASE_URL}/${e.url_key}`}
                                      >
                                        {" "}
                                        {e.label}{" "}
                                        {i + 1 !=
                                          product.extraVariables.size_option
                                            .length && ","}
                                      </Link>
                                    );
                                  }
                                )}
                              </p>
                            )}
                            <p>
                              <span>Price</span>
                              {selectedSeze == "FT"
                                ? updated_price_ft
                                  ? `Offer Price Rs ${parseFloat(
                                      updated_price_ft
                                    ).toFixed(2)}`
                                  : `MRP Rs ${parseFloat(
                                      product.extraVariables.sq_ft_price
                                    ).toFixed(2)}`
                                : updated_price_ft
                                ? `Offer Price Rs ${
                                    updated_price_ft /
                                    (0.3048 * 0.3048).toFixed(2)
                                  }`
                                : `MRP Rs ${(
                                    product.extraVariables.sq_ft_price /
                                    (0.3048 * 0.3048)
                                  ).toFixed(2)}`}
                              /sq.ft (incl. of all taxes)
                              {/* <select value={selectedSeze} onChange={(e)=>setSelectedSeze(e.target.value)}>
<option value="FT">/sq.ft</option>
<option value="Meter">/sq.meter</option>
</select> */}
                            </p>
                            {Array.isArray(product.extraVariables.design) &&
                              product.extraVariables.design?.filter(
                                (cur) => cur?.label != "false"
                              ).length > 0 && (
                                <p>
                                  <span>Design</span>
                                  {product.extraVariables.design.map((e, i) => {
                                    return (
                                      <Link
                                        key={i}
                                        href={`${config.HEADLESS_BASE_URL}/${e.url_key}`}
                                      >
                                        {" "}
                                        {e.label}{" "}
                                        {i + 1 !=
                                          product.extraVariables.design
                                            .length && ","}
                                      </Link>
                                    );
                                  })}
                                </p>
                              )}
                            {Array.isArray(
                              product.extraVariables.suitable_for
                            ) &&
                              product.extraVariables.suitable_for?.filter(
                                (cur) => cur?.label != "false"
                              ).length > 0 && (
                                <p>
                                  <span>Suitable for</span>
                                  {product.extraVariables.suitable_for.map(
                                    (e, i) => {
                                      return (
                                        <Link
                                          key={i}
                                          href={`${config.HEADLESS_BASE_URL}/${e.url_key}`}
                                        >
                                          {" "}
                                          {e.label}{" "}
                                          {i + 1 !=
                                            product.extraVariables.suitable_for
                                              .length && ","}
                                        </Link>
                                      );
                                    }
                                  )}
                                </p>
                              )}
                            {/* {videoURL && console.log("876567", videoURL)} */}
                            {/* <Button onClick={()=>addProductToCart('sample') }variant="outline-success">Order Your Free Sample</Button> */}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    {videoURL && (
                      <div className="quicklook-video-mobile">
                        <iframe
                          id="youtube-player"
                          src={videoURL}
                          frameborder="0"
                          height="300px"
                          width="100%"
                          allowfullscreen="true"
                        />
                        {/* <video width="100%" controls autoplay muted playsinline>
<source src={videoURL} type="video/mp4" />
</video> */}
                      </div>
                    )}
                    {product?.description?.html && (
                      <div className="pro_about mob">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: product.description.html,
                          }}
                        ></div>
                      </div>
                    )}
                    {product.product_links?.length > 0 && (
                      <div>
                        <h5 className="looksgoodwith_head">Looks good with</h5>
                        <div className="prolooksgoodcard">
                          {product.product_links.map((e, i) => {
                            return (
                              <div className="prolookdata" key={i}>
                                <a
                                  href={`${config.HEADLESS_BASE_URL}/${e?.url_key}`}
                                >
                                  <img src={e.image} alt="image" />
                                  <small>{e.name}</small>
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    <div className="protoolscard">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <h2>Pro Tools</h2>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="protoolsdata">
                              <div
                                className="toolscontent"
                                onClick={() =>
                                  downloadZip(product.media_gallery)
                                }
                              >
                                <FaDownload className="proToolIcon" />
                                <small>Hi-Res Image</small>
                              </div>
                              <div className="toolscontent">
                                <a
                                  href={`/pincode-based-quotation?pid=${router.query.product}`}
                                >
                                  <FaFileAlt className="proToolIcon" />
                                  <small>Request Quote</small>
                                </a>
                              </div>
                              <div
                                className="toolscontent"
                                onClick={() =>
                                  router.push("/construction-cost-calculator")
                                }
                              >
                                {/* <FaEye  className='proToolIcon'/> */}
                                <FaCalculator className="proToolIcon" />
                                <small>Cost Estimator</small>
                              </div>
                              <div className="toolscontent">
                                <a
                                  href={`/carpetlook?img=${product.media_gallery[0]?.url}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FaSlackHash className="proToolIcon" />
                                  <small>Laying Pattern</small>
                                </a>
                              </div>
                              <div className="toolscontent">
                                <a
                                  href={product.extraVariables.specifications}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FaFilePdf className="proToolIcon" />
                                  <small>Specifications</small>
                                </a>
                              </div>
                              <div
                                className="toolscontent"
                                onClick={() =>
                                  router.push(
                                    `/store-locator?sku=${product.sku}`
                                  )
                                }
                              >
                                {" "}
                                <FaStoreAlt className="proToolIcon" />
                                <small>Find A Store</small>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <CustomerReview />

                {similertiles.length && (
                  <div className="pro_similartiles">
                    <h2>Similar Tiles</h2>
                    <YouMayAlsoLike
                      products={similertiles}
                      UnbxdRecomendatoRequestID={UnbxdRecomendatoRequestID}
                      widget={"WIDGET3"}
                    />
                  </div>
                )}

                <div className="pro_about">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: product.description.html,
                    }}
                  ></div>
                </div>
                <div className="pro_about Pro_Other pdp-other-detail-row">
                  <h2>Other Details</h2>
                  <div className="pdp-other-bx">
                    <p>
                      <span className="pdp-label">Size: </span>{" "}
                      <span className="pdp-text-detail">
                        {product.extraVariables.size
                          ? product.extraVariables.size
                          : "-"}{" "}
                        mm
                      </span>
                    </p>
                    <p>
                      <span className="pdp-label">
                        Net Quantity (Tiles per box):{" "}
                      </span>{" "}
                      <span className="pdp-text-detail">
                        {product.extraVariables.tile_per_box
                          ? product.extraVariables.tile_per_box
                          : "-"}
                        N{" "}
                      </span>
                    </p>
                    <p>
                      <span className="pdp-label">Area: </span>
                      <span className="pdp-text-detail">
                        {product.extraVariables.size &&
                        product.extraVariables.tile_per_box
                          ? (() => {
                              const sizeParts =
                                product.extraVariables.size.split("x");
                              if (sizeParts.length === 2) {
                                const length = parseFloat(sizeParts[0].trim());
                                const width = parseFloat(sizeParts[1].trim());
                                const areaSqMm =
                                  length *
                                  width *
                                  product.extraVariables.tile_per_box; // Calculate area in sq mm
                                const areaSqDm = areaSqMm / 10000; // Convert area to sq dm
                                // console.log("9090", areaSqDm)
                                if (areaSqDm < 100) {
                                  return `${areaSqDm.toFixed(2)} sq Decimeter`;
                                } else {
                                  return `${(areaSqMm / 1000000).toFixed(
                                    2
                                  )} sq Meters`;
                                }
                              } else {
                                return "Invalid size format";
                              }
                            })()
                          : "-"}
                      </span>
                    </p>

                    <p>
                      <span className="pdp-label">Number of Faces: </span>{" "}
                      <span className="pdp-text-detail">
                        {product.extraVariables.number_of_faces
                          ? product.extraVariables.number_of_faces
                          : "-"}
                      </span>
                    </p>
                    {/* <p><span>Factory</span> {product.extraVariables.factory ? product.extraVariables.factory : "-"}</p> */}
                    <p>
                      <span className="pdp-label">Factory</span>{" "}
                      <span className="pdp-text-detail">
                        {product.extraVariables.factory == "Sikandrabad"
                          ? "Regd. Office: 8, Industrial Area, Sikandrabad 203205, UP, India "
                          : product.extraVariables.factory}
                      </span>
                    </p>
                    <p>
                      <span className="pdp-label">Country of origin: </span>{" "}
                      <span className="pdp-text-detail">India</span>
                    </p>
                    <p>
                      <span className="pdp-label">
                        Recommended Laying Pattern:{" "}
                      </span>{" "}
                      <span className="pdp-text-detail">
                        {product.extraVariables.recommended_laying_patter
                          ? product.extraVariables.recommended_laying_patter
                          : "-"}
                      </span>
                    </p>
                  </div>
                </div>
                {/* <div className='pro_youmayalso'>
         <h2 className='productpage_title'><span>You may also like</span></h2>
         <Slider  {...youmayalso} className="category-menu">
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
            <div>
               <img src="../ee.jpg" alt=''/>
            </div>
         </Slider>
      </div> */}
                {youmayalsolikee.length ? (
                  <div className="pro_youmayalso">
                    <h2 className="productpage_title">
                      <span>You May Also Like</span>
                    </h2>
                    <YouMayAlsoLike
                      products={youmayalsolikee}
                      UnbxdRecomendatoRequestID={UnbxdRecomendatoRequestID}
                      widget={"WIDGET1"}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                {throwConfetti && (
                  //         <Confetti
                  //         numberOfPieces={300}
                  //         tweenDuration={10}
                  //         width={width}
                  //         height={height}
                  //   colors={['#009444', '#ffca34']}

                  // style={{
                  //    zIndex: 9999,
                  //    position: 'fixed',
                  //    top: 0,
                  //    left: 0,
                  //    width: '100vw',
                  //    height: '100vh',
                  //  }}
                  // />

                  <Fireworks
                    options={{
                      rocketsPoint: {
                        min: 0,
                        max: 100,
                      },
                    }}
                    style={{
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      position: "fixed",
                    }}
                  />
                )}
                <div
                  id="syte-shop-the-look-container"
                  data-sku={product.sku}
                  data-image-src={product.image?.url}
                ></div>
                <div className="pro_writereview">
                  <h2>Write A Review / Comment</h2>
                  <Row>
                    <Col md={6} xs={12}>
                      <AddReviews productId={product.id} />

                      <div className="pro_writereview_data">
                        {reviews.map((e, i) => {
                          return (
                            <div className="pro_writereview_content" key={i}>
                              <div className="review_iden">
                                <img src="../review_dummy.png" alt="image" />
                                <small>{e.customer_name}</small>
                              </div>
                              <p className="review_rat"></p>
                              <ReactStars
                                count={5}
                                value={e.rating}
                                edit={false}
                                color2={"#ff5e00"}
                                style={{ paddingRight: "5px" }}
                              />
                              <small> {e.rating} out of 5 stars </small>

                              <small>Post at {e.created_at}</small>
                              {/* <small>Colour: Beige | Size: 600 * 600 | Pattern: Floral</small> */}
                              <p className="review_com">{e.detail}</p>

                              {e.review_image?.length > 0 && (
                                <div className="review_images">
                                  {e.review_image.map((item, i) => {
                                    return (
                                      <img
                                        key={i}
                                        src={item.image_url}
                                        alt="image"
                                      />
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          )}
          <Modal
            show={getInTouch}
            className="pincode-popup-bx expert_assistance_modal"
            onHide={() => {
              setGetInTouch(false);
            }}
          >
            <Modal.Dialog>
              <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: "15px !important" }}>
                  We are unable to determine the pricing for your pincode .
                  Kindly leave your details and we will get back to you to help
                  you with your order.
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    submitGetInTouch(
                      `Zerotransport Website ${
                        product.extraVariables.factory
                          ? product.extraVariables.factory
                          : ""
                      }`
                    );
                  }}
                >
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name*"
                      onChange={(e) => {
                        setTouch({
                          ...touch,
                          name: e.target.value,
                        });
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Mobile</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Mobile Number*"
                      onChange={(e) => {
                        setTouch({
                          ...touch,
                          number: e.target.value,
                        });
                      }}
                    />
                  </Form.Group>
                  {touch.error && (
                    <p className="error text-danger">{touch.error}</p>
                  )}
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={touch.loading}
                    style={{ width: "100%" }}
                  >
                    {touch.loading ? "Submitting" : "Submit"}
                  </Button>
                </Form>
              </Modal.Body>
            </Modal.Dialog>
          </Modal>
        </>
      )}
    </>
  );
};
export default Product;
